import { render, staticRenderFns } from "./LeagueEvent.vue?vue&type=template&id=a06250e0&"
import script from "./LeagueEvent.vue?vue&type=script&lang=js&"
export * from "./LeagueEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports